import { STATUS } from "@/lib/format";

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.borrador;
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const PendingBadge = ({ testid }) => (
  <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-800">
    Procesador pendiente de conexión
  </span>
);
